module.exports = {"420116001":"前川街道","420116002":"祁家湾街道","420116003":"横店街道","420116004":"罗汉寺街道","420116005":"滠口街道","420116006":"六指街道","420116007":"天河街道","420116008":"王家河街道","420116009":"长轩岭街道","420116010":"李集街道","420116011":"姚集街道","420116012":"蔡榨街道","420116013":"武湖街道","420116014":"三里桥街道","420116015":"蔡店街道","420116201":"木兰乡","420116401":"木兰山风景区管理处","420116402":"大潭","420116403":"盘龙城经济开发区","420116404":"汉口北商贸物流枢纽区管委会"}


//////////////////
// WEBPACK FOOTER
// ./src/town/420116.json
// module id = 1832
// module chunks = 0